import React from 'react';
import { FaEdit, FaTrashAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { formatDateString } from '../../../../utils/dateUtils';
import styles from './Matrices.module.css';

const MatrixList = ({ 
    matrices, 
    loading, 
    onEdit, 
    onDelete,
    searchQuery,
    setSearchQuery 
}) => {
    if (loading) {
        return (
            <div className={styles.loading}>
                <div className={styles.spinner}></div>
                <p>Loading matrices...</p>
            </div>
        );
    }

    if (matrices.length === 0 && !searchQuery) {
        return (
            <div className={styles.emptyState}>
                <h3>No Matrices Found</h3>
                <p>Create your first matrix to get started.</p>
            </div>
        );
    }

    return (
        <div className={styles.listContainer}>
            {/* Table Header with Search */}
            <div className={styles.tableHeader}>
                <div className={styles.tableHeaderContent}>
                    <h3>Matrices ({matrices.length})</h3>
                    <div className={styles.tableFilters}>
                        <div className={styles.filterGroup}>
                            <label htmlFor="searchFilter">Search:</label>
                            <input
                                id="searchFilter"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search by name, type, or description..."
                                className={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.table}>
                <div className={styles.tableHead}>
                    <div className={styles.row}>
                        <div className={styles.cell}>Matrix Code</div>
                        <div className={styles.cell}>Matrix Name</div>
                        <div className={styles.cell}>Type</div>
                        <div className={styles.cell}>Description</div>
                        <div className={styles.cell}>Status</div>
                        <div className={styles.cell}>Actions</div>
                    </div>
                </div>
                <div className={styles.tableBody}>
                    {matrices.length === 0 && (
                        <div className={styles.noResults}>
                            <p>No matrices match your search criteria</p>
                        </div>
                    )}
                    {matrices.map(matrix => (
                        <div key={matrix.matrixId} className={styles.matrixRow}>
                            <div className={styles.row}>
                                <div className={styles.cell}>
                                    <div className={styles.nameCell}>
                                        <span className={styles.name}>
                                            {matrix.matrix}
                                        </span>
                                        <span className={styles.id}>ID: {matrix.matrixId}</span>
                                    </div>
                                </div>
                                <div className={styles.cell}>
                                    {matrix.matrixType ? (
                                        <span className={`${styles.typeBadge} ${styles[matrix.matrixType.toLowerCase()]}`}>
                                            {matrix.matrixType}
                                        </span>
                                    ) : (
                                        <span className={styles.noDescription}>No type</span>
                                    )}
                                </div>
                                <div className={styles.cell}>
                                    <div className={styles.description}>
                                        {matrix.description || <span className={styles.noDescription}>No description</span>}
                                    </div>
                                </div>
                                <div className={styles.cell}>
                                    <span className={`${styles.statusBadge} ${matrix.active ? styles.statusActive : styles.statusInactive}`}>
                                        {matrix.active ? (
                                            <>
                                                <FaCheckCircle /> Active
                                            </>
                                        ) : (
                                            <>
                                                <FaTimesCircle /> Inactive
                                            </>
                                        )}
                                    </span>
                                </div>
                                <div className={styles.cell}>
                                    <div className={styles.actions}>
                                        <button
                                            className={styles.editButton}
                                            onClick={() => onEdit(matrix)}
                                            title="Edit"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            className={styles.deleteButton}
                                            onClick={() => {
                                                if (window.confirm(
                                                    `Are you sure you want to delete matrix "${matrix.matrix}"?\n\n` +
                                                    'Note: Consider deactivating instead if this matrix has been used in historical samples.'
                                                )) {
                                                    onDelete(matrix.matrixId);
                                                }
                                            }}
                                            title="Delete"
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MatrixList;
